import React, { useState, useEffect } from "react";
import TextEditor from "../../ui/editor";
import {
  getStudentIdData,
  addData,
  updateData,
} from "../../../lib/studentadditionaolinfo";

export default function GlobalAdditionalInfo({ slug }) {
  const [instructorNote, setInstructorNote] = useState("");
  const [studentNote, setStudentsNote] = useState("");
  const [detail, setDetail] = useState("");
  const [recId, setRecId] = useState(0);
  const [showmessage, setShowMessage] = useState(false);

  async function GetData() {
    const data = await getStudentIdData(slug);
    //console.log("data", data);
    if (data.length > 0) {
      setRecId(data[0].id);
      setStudentsNote(data[0].studentNote);
      setInstructorNote(data[0].instructorNote);
      setDetail(data[0].detail);
    }
    setShowMessage(false);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    //if is recId update else insert
    if (recId > 0) {
      await updateData({
        id: recId,
        studentId: slug,
        studentNote: studentNote,
        instructorNote: instructorNote,
        detail: detail,
      });
    } else {
      await addData({
        studentId: slug,
        studentNote: studentNote,
        instructorNote: instructorNote,
        detail: detail,
      });
    }

    setShowMessage(true);
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    GetData();
  }, [slug]);

  return (
    <div className="p-2 bg-white rounded shadow-sm">
      <h3 className="text-center mb-2 text-dark">Additional Info</h3>
      {showmessage && (
        <div
          className="alert alert-success alert-dismissible fade show"
          role="alert"
        >
          <strong>Updated!</strong> Your Settings.
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="alert"
            aria-label="Close"
          ></button>
        </div>
      )}
      <form role="form" onSubmit={handleSubmit}>
        <label>
          Do you wish to provide details of circumstances or qualifications not
          reflected in the application
        </label>

        <hr />
        <div className="mb-3">
          <label
            htmlFor="counselorsNote"
            className="form-label fw-bold text-dark"
          >
            Counselor&apos;s Note:
          </label>
          <textarea
            id="counselorsNote"
            rows="3"
            value={instructorNote}
            onChange={(e) => setInstructorNote(e.target.value)}
            className="form-control"
            style={{ backgroundColor: "#cfe2f3", resize: "none" }}
          />
        </div>
        <div className="mb-3">
          <label
            htmlFor="studentsNote"
            className="form-label fw-bold text-dark"
          >
            Students Note:
          </label>
          <textarea
            id="studentsNote"
            rows="3"
            value={studentNote}
            onChange={(e) => setStudentsNote(e.target.value)}
            className="form-control"
            style={{ backgroundColor: "#cfe2f3", resize: "none" }}
          />
        </div>

        <div className="mb-3">
          <label htmlFor="MainEssay" className="form-label fw-bold text-dark">
            Details:
          </label>
          <div className="form-group">
            <div id="editor">
              <TextEditor value={detail} setValue={setDetail} />
            </div>
          </div>
        </div>
        <br />
        <hr />
        <br />
        <button type="submit" className="btn btn-primary">
          Update Additional Info
        </button>
      </form>
    </div>
  );
}
